import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { ToolsClass } from '@/common/class/tools.class'
import { TOPUP_PHONE_WITH_PREFIX_LENGTH, TOPUP_PHONE_WITHOUT_PREFIX_LENGTH } from '@/common/const/topup.const'
import { TOPUP_DEFAULT_PREFIX } from '@/orange/const/topup.const'

export default {
  data () {
    return {
      showProcessError: false,
      formData: {
        msisdn: null,
        description: null,
        threshold: null,
        amount: null,
        paymentMethodType: null
      }
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.contacts.loading,
      contactId: state => state.contacts.form.id,
      isPhoneValid: state => state.contacts.form.isPhoneValid === true,
      isPhoneError: state => {
        return state.contacts.form.isPhoneValid === false ||
          state.contacts.form.isPhoneEmpty === true ||
          state.contacts.form.isPhoneUnique === false ||
          state.contacts.form.isCheckPhoneStatusValid === false
      },
      isPhoneEmpty: state => state.contacts.form.isPhoneEmpty === true,
      isPhoneUnique: state => state.contacts.form.isPhoneUnique !== false,
      isNameEmpty: state => !state.contacts.form.description || !state.contacts.form.description.length,
      isCheckPhoneInProgress: state => state.contacts.form.checkPhoneInProgress,
      isCheckPhoneNotSet: state => state.contacts.form.isCheckPhoneStatusValid === null,
      isCheckPhoneError: state => state.contacts.form.isCheckPhoneStatusValid === false
    }),
    ...mapGetters({
      contactsList: 'getContactsList'
    })
  },
  methods: {
    ...mapMutations([
      'SET_CONTACTS_FORM_PHONE',
      'SET_CONTACTS_FORM_NAME',
      'SET_CONTACTS_FORM_PHONE_UNIQUE',
      'SET_CONTACTS_FORM_PHONE_VALID',
      'SET_CONTACTS_FORM_CHECK_PHONE_STATUS_VALID',
      'SET_CONTACTS_FORM_CHECK_PHONE_IN_PROGRESS',
      'SET_CONTACTS_FORM_PHONE_EMPTY'
    ]),
    ...mapActions([
      'checkPhoneStatus',
      'getContacts'
    ]),
    isPhoneNumberUnique (phone) {
      phone = ToolsClass.cleanPhoneNumber(phone)
      phone = ToolsClass.getPhoneNumberWithoutPrefix(phone)
      let matchedPhone = this.contactsList.find(contact => ToolsClass.getPhoneNumberWithoutPrefix(contact.msisdn) === phone)
      if (!matchedPhone) {
        return true
      }
      return this.contactId && matchedPhone.id === this.contactId
    },
    checkPhoneOnPaste (event) {
      let paste

      if (window.clipboardData && window.clipboardData.getData) {
        paste = window.clipboardData.getData('Text')
      } else if (event.clipboardData && event.clipboardData.getData) {
        paste = (event.clipboardData || window.clipboardData).getData('text')
      }

      if (paste && paste.length) {
        this.checkPhone()
      }
    },
    checkPhone () {
      let phone = this.formData.msisdn !== null ? String(this.formData.msisdn) : ''
      this.SET_CONTACTS_FORM_PHONE_UNIQUE(null)
      this.SET_CONTACTS_FORM_PHONE_VALID(null)
      this.SET_CONTACTS_FORM_CHECK_PHONE_STATUS_VALID(null)
      this.SET_CONTACTS_FORM_CHECK_PHONE_IN_PROGRESS(false)

      if (!phone || !phone.length) {
        this.SET_CONTACTS_FORM_PHONE_EMPTY(true)
        return
      }

      this.SET_CONTACTS_FORM_PHONE(phone)
      this.SET_CONTACTS_FORM_PHONE_EMPTY(false)

      if (ToolsClass.cleanPhoneNumber(phone).length < TOPUP_PHONE_WITHOUT_PREFIX_LENGTH) {
        this.SET_CONTACTS_FORM_PHONE_VALID(false)
        return
      }
      this.SET_CONTACTS_FORM_PHONE_VALID(true)

      if (!ToolsClass.isPhoneNumberValid(phone)) {
        this.SET_CONTACTS_FORM_PHONE_VALID(false)
        return
      }

      if (!this.isPhoneNumberUnique(this.formData.msisdn)) {
        this.SET_CONTACTS_FORM_PHONE_UNIQUE(false)
        return
      } else {
        this.SET_CONTACTS_FORM_PHONE_UNIQUE(true)
      }

      this.SET_CONTACTS_FORM_CHECK_PHONE_IN_PROGRESS(true)

      phone = ToolsClass.cleanPhoneNumber(this.formData.msisdn)
      if (phone.length < TOPUP_PHONE_WITH_PREFIX_LENGTH) {
        phone = TOPUP_DEFAULT_PREFIX + phone
      }
      let data = {
        operator: this.$VUE_APP_OPERATOR,
        account: phone,
        amount: 5.00
      }
      this.checkPhoneStatus(data)
        .then(response => {
          if (response.body.status === 1) {
            this.SET_CONTACTS_FORM_CHECK_PHONE_STATUS_VALID(true)
          } else {
            this.SET_CONTACTS_FORM_CHECK_PHONE_STATUS_VALID(false)
          }
        })
        .finally(() => {
          this.SET_CONTACTS_FORM_CHECK_PHONE_IN_PROGRESS(false)
        })
        .catch(() => {
          this.SET_CONTACTS_FORM_CHECK_PHONE_STATUS_VALID(false)
        })
    }
  }
}
